import React, {useState} from 'react';
import i18n from 'i18next';

import {ConfirmMessage, SecondaryButton} from 'components';

import DuplicateIconSrc from 'assets/icons/duplicate.svg';

type Props = {
  onClick: () => void;
};

export default function DuplicateButton({onClick}: Props) {
  const [promptVisible, setPromptVisible] = useState(false);

  return (
    <div className="relative">
      <SecondaryButton
        className="ml-2"
        style={{padding: '0.25rem'}}
        onClick={() => setPromptVisible(!promptVisible)}
      >
        <div className="flex">
          <span className="p-2 font-semibold">
            {i18n.t('wisbitPage.index.duplicate.title')}
          </span>
          <img
            src={DuplicateIconSrc}
            alt={i18n.t('wisbitPage.index.duplicate.title')}
            className="mr-2"
          />
        </div>
      </SecondaryButton>
      {promptVisible && (
        <ConfirmMessage
          className="w-84 right-0"
          cancelText={i18n.t('wisbitPage.index.duplicate.cancel')}
          onCancel={() => setPromptVisible(false)}
          confirmText={i18n.t('wisbitPage.index.duplicate.confirm')}
          onConfirm={onClick}
        >
          {i18n.t('wisbitPage.index.duplicate.prompt')}
        </ConfirmMessage>
      )}
    </div>
  );
}
